import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';

type LogApplyFilterParams = {
  itemLogging?: AnyObject;
  overrides?: AnyObject;
};

export const useLogApplyFilter = (logging: AnyObject) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(
    ({ itemLogging, overrides }: LogApplyFilterParams) => {
      logAnalyticsEvent({
        name: 'APPLY_FILTER',
        ably_only_log: {
          ...logging.ably_only_log,
          ...itemLogging?.ably_only_log,
        },
        analytics: {
          ...logging.analytics,
          ...itemLogging?.analytics,
          ...overrides,
        },
      });
    },
    [logAnalyticsEvent, logging],
  );
};